/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import { Trans } from "react-i18next";
import i18next from "i18next";
import Helpers from "util/helpers";
import { SCORMURL, ENV_NAME } from "util/constant";
import toastr from "toastr";
import { api } from "api";

class ApproveModal extends Component {
  registerVideo = (training) => {
    const timePlanId = training.timeplans[0].timePlanId;
    this.props.onProcessBegin();
    api
      .post("/api/training-catalog/registration", { timePlanId: timePlanId })
      .then((response) => {
        this.props.onSuccess();
        let langCode = Helpers.getLangCode(localStorage.getItem("i18nextLng"));
        window.open(
          `${SCORMURL}/index?employeeCode=${this.props.employeeCode}&registeredTrainingId=${response.data.data.id}&langCode=${langCode}&env=${ENV_NAME}`
        );
      })
      .catch((err) => {
        toastr.error(err.response.data.message);
      })
      .finally(() => {
        this.props.onProcessEnd();
      });
  };

  render() {
    return (
      <div>
        {this.props.spinner}
        {i18next.t("trainingcatalog_price")}
        <div
          className="d-flex justify-content-center mt-4"
          style={{ gap: "10px" }}
        >
          <button
            type="button"
            className="btn btn-sm btn-cancel"
            onClick={() => this.props.onCancel()}
          >
            <Trans>trainingcatalog_cancel</Trans>
          </button>
          <button
            type="button"
            className="btn btn-sm btn-save"
            onClick={() => this.registerVideo(this.props.training)}
          >
            <Trans>trainingcatalog_approve</Trans>
          </button>
        </div>
      </div>
    );
  }
}
export default containsLongRunningProcess(ApproveModal);
